export const DEFAULT_HEADER_PROPS = {
    backButtonAriaLabel: 'back',
    closeButtonAriaLabel: 'Close Drawer',
};

export const DRAWER_WIDTH = '350px';

export const DRAWER_BODY_SX = { padding: '0 0' };
export const ERROR_SX = { padding: 2 };
export const DRAWER_SX = { zIndex: '20099' };   // To bring the drawer above the WCS Costco menu
export const BODY_SX = {
    display: 'flex',
    flexDirection: 'column',
    gap: '0',
    padding: '0 0',
};